<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="padding-bottom: 60px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Submission ID </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="searchParam.SubmissionID" name="search" clearable></el-input>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Entry Number </label>
          <div class="col-sm-2 dfb">
            <div>
              <el-input
                v-model="searchParam.EntryNumber1"
                placeholder="3 Char "
                name="search"
                clearable
              ></el-input> 
            </div>
            <div>-</div>
          </div>
          <div class="col-sm-2">
            <div>
              <el-input
                v-model="searchParam.EntryNumber2"
                placeholder="8 Char "
                name="search"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Submission Date </label>
          <div class="col-sm-4">
            <div>
              <el-date-picker
                v-model="searchParam.SubmissionDate"
                type="daterange"
                range-separator="-"
                start-placeholder="The start time"
                end-placeholder="The end of time"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <!-- <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Rating </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="rating" clearable placeholder="A/B/C/D">
                <el-option
                  v-for="item in Rating"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div> -->
        <!-- <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Search </label>
          <div class="col-sm-4">
            <div>
              <el-input
                v-model="keywords"
                placeholder="Keywords of Reference Number "
                name="search"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div> -->
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Category </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="searchParam.level" clearable >
                <el-option
                  v-for="item in Level"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" style="opacity: 0">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Filter Status </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="searchParam.searchStatus" placeholder="Status" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <el-button type="primary" @click="judgementSearch">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="form-group margin-0">
          <div class="form-group" style="text-align: right">
            <el-button type="primary" @click="exportAll">Export All</el-button>
          </div>
        </div>
        <template>
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column type="index" label="S/N" fixed width="60"> </el-table-column>
            <el-table-column prop="submissionId" label="Submission ID">
            </el-table-column>
            <el-table-column prop="submissionDate" label="EO form Submission Date">
            </el-table-column>
            <el-table-column prop="uploadCode" label="Entry  Number">
            </el-table-column>
            <el-table-column prop="level" label="Category"> </el-table-column>
            <el-table-column prop="status" label="Status"> </el-table-column>

            <!-- <el-table-column prop="updatedBy" label="User Name">
            </el-table-column> -->

            <el-table-column label="Action" fixed="right" width="70">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  icon="el-icon-edit"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="el-table_footertoolbar">
            <el-pagination
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="searchParam.pageSize"
              :total="total"
              style="float: right"
            >
            </el-pagination>
          </el-col>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
    searchParam:{
      EntryNumber1:'',
      EntryNumber2:'',
      SubmissionDate:[],
      pageIndex:1,
      pageSize:10,
      keywords:'',
      searchStatus:'',
      SubmissionID:"",
      submissionType:3,
      rating:"",
      level:"",
      sortName:"",
      sortType:""
    },
      Rating: ["A", "B", "C", "D"],
       Level: [
        {
          value: "5",
          label: "Primary School",
        },
        {
          value: "6",
          label: "Secondary School",
        },
        {
          value: "7",
          label: "Open",
        },
       ],
      total: null,
      tableData: [],
      category: {
        // 1: "Junior Primary",
        // 2: "Senior Primary",
        // 3: "Junior Secondary",
        // 4: "Senior Secondary",
        5: "Primary School",
        6: "Secondary School",
        7: "Open",
      },
      status: {
        0: "SUBMITTED",
        1: "APPROVED",
        2: "REJECTED",
        "-1": "APPLIED",

      },

      options: [
        {
          value: "0",
          label: "Submitted",
        },
        {
          value: "1",
          label: "Approved",
        },
        {
          value: "2",
          label: "Rejected",
        },
        {
          value: "-1",
          label: "Applied",
        }
      ],
    };
  },
  created() {
    this.intiPage()
    this.stemupList();
  },
  components: {
    draggable,
  },
  methods: {
    intiPage(){
      const storeParam = this.$store.state.hsbcOnlineSubmissionSearchParam
      this.searchParam={...storeParam}
    },
    handleSizeChange(val) {
      this.searchParam.pageSize = val;
      this.$store._mutations.setHsbcOnlineSubmissionSearchParam[0](this.searchParam)
      this.stemupList();
    },
    handleCurrentChange(val) {
      this.searchParam.pageIndex = val;
      this.$store._mutations.setHsbcOnlineSubmissionSearchParam[0](this.searchParam)
      this.stemupList();
    },
    judgementSearch() {
      this.searchParam.pageIndex = 1
      this.$store._mutations.setHsbcOnlineSubmissionSearchParam[0](this.searchParam)
      this.stemupList();
    },
    handleEdit(index, row) {
      this.$router.push({
        path: "/main/sideMenu1",
        query: {
          id: row.id,
          submissionType:this.searchParam.submissionType
        },
      });
    },
    async exportAll() {
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.stemupExport;
      objdata.submissionType = this.searchParam.submissionType;
      let data = await this.$store.dispatch(
        "apiEventFromDataDownload",
        objdata
      );
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ItemChangeRecord.xls");
      document.body.appendChild(link);
      link.click();
    },
    async stemupList() {
      var objdata = this.getAuthObj();
      this.$store._mutations.setHsbcOnlineSubmissionSearchParam[0](this.searchParam)
      if (this.EntryNumber1 || this.searchParam.EntryNumber2) {
        objdata.entryNo = this.searchParam.EntryNumber1 + "-" + this.searchParam.EntryNumber2;
      } else {
        objdata.entryNo = "";
      }
      if (this.searchParam.SubmissionDate&&this.searchParam.SubmissionDate.length) {
        objdata.begSubmisstionDate = this.searchParam.SubmissionDate[0] + " 00:00:00";
        objdata.endSubmisstionDate = this.searchParam.SubmissionDate[1] + " 23:59:59";
      }
      objdata.pageIndex = this.searchParam.pageIndex;
      objdata.pageSize = this.searchParam.pageSize;
      objdata.keywords = this.searchParam.keywords;
      objdata.status = this.searchParam.searchStatus;

      objdata.submisstionId = this.searchParam.SubmissionID;
      objdata.submissionType = this.searchParam.submissionType;

      objdata.rating = this.searchParam.rating;
      objdata.level = this.searchParam.level;

      objdata.sortName = this.searchParam.sortName;
      objdata.sortType = this.searchParam.sortType;
      objdata.apiUrl = this.apiConfig.stemupList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.tableData = data.data.result.stemupList;
      this.tableData.forEach((element) => {
        element.level = this.category[element.level];
        element.status = this.status[element.status];
      });
      this.total = data.data.result.total;
    },
  },
  mounted() {},
};
</script>
